import { Component } from '@angular/core';
import { Mock4allSingletonService } from "libraries/mock4all/mock4all-singleton.service";

@Component({
  selector: 'mock4all-input',
  template: `
    <input #mockInput
           *permissionIf="'developer.mock4all.use'"
           type="text"
           name="mockId"
           class="mock-input e2e-mock-input"
           placeholder="MockId"
           [(ngModel)]="mock4allSingletonService.mockId" />
  `,
  styles: [`
    .mock-input {
      margin-left: 1em;
      margin-right: 1em;
    }
    input {
      border : 1px solid #e6eaed;
      padding : .325rem
    }
  `]
})
export class Mock4allInputComponent {

  constructor(public readonly mock4allSingletonService: Mock4allSingletonService) { }

}
